import React, { useEffect, useRef, useState } from 'react';
import { Loading } from 'react-lib/dist/components-es';
import { withTranslation } from 'react-i18next';
import { compose } from 'redux';
import connect from 'react-redux/es/connect/connect';
import PropTypes from 'prop-types';

import { Button, Grid, Segment } from 'semantic-ui-react';
import { entityType as et, entityType } from '../../constants';
import { filterActions } from '../../behavior/filter';

import OverviewTable from '../Filtering/OverviewTable/OverviewTable';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import FilteringContextProvider from '../Filtering/FilteringContextProvider';
import { initSelectors } from '../../behavior/init';
import { useTitleProvider } from '../TitleContextProvider';
import useUser from '@behavior/init/getUserV2';
import { useTranslation } from 'react-i18next';

const BatchUpdateSelectedContainer = ({
  actions,
  entityTypeProps,
  allFilters,
  filteredList,
  setSelectedInventoriesCounter,
  setSelectedInventoriesParent,
  selectedRowsFromOverviewPage,
  parentFilterContextRef,
  setSelectedRowsAndConvertToObj,
}) => {
  const { user } = useUser();
  const [titleState, dispatch] = useTitleProvider();
  const { t } = useTranslation();
  useEffect(() => {
    //batchUpdateSelected has the same table structure as batchUpdate. Thus we copy most of the properties in order to avoid
    //additional requests executed by initializeFiltering. Deep copy is necessary
    allFilters[entityType.batchUpdateSelected] = JSON.parse(
      JSON.stringify(allFilters[entityType.batchUpdate])
    );
    allFilters.batchUpdateSelected.filteredList.entityType = entityTypeProps;
    allFilters.batchUpdateSelected.filteredList.result = [];
  }, []);

  useEffect(() => {
    //If we receive rows from overview page (when 'Batch Update' button is pressed when rows are selected), we need to fetch the
    //inventories from the database
    if (
      selectedRowsFromOverviewPage !== undefined &&
      Object.keys(selectedRowsFromOverviewPage).length !== 0
    ) {
      filterState.pageSize = 999999;
      setIsLoading(true);
      selectedRowsFromOverviewPage = {
        ...selectedRowsFromOverviewPage,
        ...titleState.selectedRowsForBatchUpdate,
      };
      /* console.log({
         ID: Object.keys(selectedRowsFromOverviewPage).map(o => ({ label: o, value: o }))
       });*/
      actions.applyFilterAction('batchUpdateSelected', filterState, {
        ID: Object.keys(selectedRowsFromOverviewPage).map(o => ({ label: o, value: o })),
      });
    }
  }, [selectedRowsFromOverviewPage]);

  const filteringContextProviderRef = useRef(null);

  const filterProps = allFilters[entityType.batchUpdate] || {}; //we are copying properties from the batchUpdate search table
  const [selectedInventories, setSelectedInventories] = useState([]);
  const [selectedInventoriesPaginate, setSelectedInventoriesPaginate] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (
      allFilters.batchUpdateSelected !== undefined &&
      allFilters.batchUpdateSelected.filteredList !== undefined
    ) {
      if (
        allFilters.batchUpdateSelected.filteredList.result.length > 0 &&
        allFilters.batchUpdateSelected.filteredList.result !== selectedInventories
      ) {
        updateSelectedInventoriesPaginate(allFilters.batchUpdateSelected.filteredList.result);
        allFilters.batchUpdateSelected.filteredList.result = [];
        setIsLoading(allFilters.isLoading);
      }
    }
  });

  const defaultFilteredList = {
    result: {
      result: [],
      totalPages: 1,
      totalElements: 0,
      entityType: entityTypeProps,
    },
  };

  let filterState = {
    visibleColumns: filterProps.visibleColumnsList,
    page: 1,
    pageSize: 10,
    sort: {
      sortField: '',
      sortDirection: '',
    },
  };

  let filterPropsOverriden = {
    visibleFieldsList: filterProps.visibleColumnsList,
    possibleFieldsList: filterProps.visibleColumnsList,
    possibleColumnsList: filterProps.visibleColumnsList,
    visibleColumnsList: filterProps.visibleColumnsList,
    isLoadingFilter: false,
    isLoading: false,
    filteredList: {
      result: selectedInventoriesPaginate,
      totalPages:
        selectedInventories.length === 0
          ? 1
          : 1 + Math.floor((selectedInventories.length - 1) / filterState.pageSize),
      totalElements: selectedInventories.length,
      entityType: entityTypeProps,
    },
  };

  const applyFilterActionsFunc = (entityType, filterStateParam, filters) => {
    filterState.page = filterStateParam.page;
    updateSelectedInventoriesPaginate(selectedInventories);
  };

  const updateSelectedInventoriesPaginate = selectedInventories => {
    let selectedInventoriesFilteredPerRole = [];
    selectedInventories.forEach((entryInv, index, object) => {
      if (!initSelectors.isRowDisabled(user, entryInv, et.batchUpdate)) {
        selectedInventoriesFilteredPerRole.push(entryInv);
      }
    });

    selectedInventories = JSON.parse(JSON.stringify(selectedInventoriesFilteredPerRole));

    setSelectedInventoriesCounter(selectedInventories.length);
    setSelectedInventories(selectedInventories);

    //update parent
    setSelectedInventoriesParent(selectedInventories);
    let selectedRows = Object.assign({}, ...selectedInventories.map(inv => ({ [inv.ID]: true })));
    setSelectedRowsAndConvertToObj(selectedRows);

    setSelectedInventoriesPaginate(
      selectedInventories.slice(
        (filterState.page - 1) * filterState.pageSize,
        filterState.page * filterState.pageSize
      )
    );
  };

  return (
    <>
      <Grid.Column width={1} style={{ margin: '0 0 0 5px', padding: '0px', flex: '0 0 60px' }}>
        <Loading isLoading={isLoading} />
        <Segment basic style={{ display: 'flex', alignItems: 'center', textAlign: 'center' }}>
          <div>
            {/*  >  */}
            <Button
              size="tiny"
              color="blue"
              icon="angle right"
              className="mouseCursorPointer"
              onClick={() => {
                if (parentFilterContextRef.current) {
                  setSelectedRowsAndConvertToObj(parentFilterContextRef.current.state.selectedRows);
                  //parentFilterContextRef.current.setSelectedRows({});
                }
                updateSelectedInventoriesPaginate(filteredList);
              }}
            />
            {/*  >>  */}
            <Button
              size="tiny"
              color="blue"
              icon="angle double right"
              className="mouseCursorPointer"
              style={{ marginTop: '5px' }}
              onClick={() => {
                if (parentFilterContextRef.current) {
                  dispatch(prevState => ({ ...prevState, selectedRowsForBatchUpdate: {} }));
                  setSelectedRowsAndConvertToObj({});
                  parentFilterContextRef.current.setSelectedRows({});
                }
                filterState.pageSize = 999999;
                filterState.filterLogicalOperator = 'AND';
                setIsLoading(true);
                actions.applyFilterAction(
                  'batchUpdateSelected',
                  filterState,
                  allFilters.batchUpdate.filters
                );
              }}
            />
            {/*  <<  */}
            <Button
              size="tiny"
              color="blue"
              icon="angle double left"
              className="mouseCursorPointer"
              style={{ marginTop: '5px' }}
              onClick={() => {
                if (parentFilterContextRef.current) {
                  setSelectedRowsAndConvertToObj({});
                  parentFilterContextRef.current.setSelectedRows({});
                }
                filteringContextProviderRef.current.handleFilterStateChanged({ page: 1 });
                updateSelectedInventoriesPaginate([]);
                filteringContextProviderRef.current.setSelectedRows({});
              }}
            />
            {/*  <  */}
            <Button
              size="tiny"
              color="blue"
              icon="angle left"
              className="mouseCursorPointer"
              style={{ marginTop: '5px' }}
              onClick={() => {
                if (filteringContextProviderRef.current) {
                  Object.keys(filteringContextProviderRef.current.state.selectedRows).forEach(
                    entry => {
                      selectedInventories.forEach((entryInv, index, object) => {
                        if (entry === entryInv.ID) {
                          object.splice(index, 1);
                        }
                      });
                    }
                  );
                  updateSelectedInventoriesPaginate(selectedInventories);
                  filteringContextProviderRef.current.setSelectedRows({});
                }
              }}
            />
          </div>
        </Segment>
      </Grid.Column>
      <Grid.Column style={{ margin: '0 5px 0 5px', padding: '0 10px 0 0' }}>
        <Loading isLoading={isLoading} />
        <AccordionWrapper
          titleClassName={'accordionHeaderCompact'}
          className="filterPanel batchUpdateSelectedList"
          accordionTitle={'3. ' + t('inventory.batch.update.selected.result')}
          closable={false}
          render={() => (
            <FilteringContextProvider
              ref={filteringContextProviderRef}
              entityType={entityTypeProps}
              visibleColumns={filterProps.visibleColumnsList}
              visibleFields={filterProps.visibleFieldsList}
              actions={{
                applyFilterAction: applyFilterActionsFunc,
                initializeFiltering: actions.initializeFiltering,
              }}
              isLoading={false}
              filterProps={filterPropsOverriden}
              filterState={filterState}
              defaultFilteredList={defaultFilteredList}
              tableOptions={[]}
              selectedRows={{}}
            >
              <OverviewTable
                renderColumnSelector={false}
                renderSorting={false}
                renderRecordsPerPage={false}
              />
            </FilteringContextProvider>
          )}
        />
      </Grid.Column>
    </>
  );
};

BatchUpdateSelectedContainer.propTypes = {
  entityTypeProps: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({
  allFilters: state.filter,
  entityTypeProps: entityType.batchUpdateSelected,
});

const mapDispatchToProps = dispatch => ({
  actions: {
    initializeFiltering: entityType => dispatch(filterActions.initializeFiltering(entityType)),
    applyFilterAction: (entityType, filterState, filters) =>
      dispatch(filterActions.applyFilterV2(entityType, filterState, filters)),
  },
});

export default compose(
  withTranslation(),
  connect(mapStateToProps, mapDispatchToProps)
)(BatchUpdateSelectedContainer);
